import {
  AchProcessingSpeed,
  BankAccountType,
  Currency,
  PaymentMethod,
  PaymentProvider,
  TransactionStatus
} from "../chunk-VZXPAOBM.js";

// transaction/transaction.schema.ts
import { z } from "zod";
var AchDetailsSchema = z.object({
  bankAccountId: z.string().uuid(),
  processingSpeed: z.nativeEnum(AchProcessingSpeed),
  entryDescription: z.string().min(1).max(100),
  expectedSettlementDate: z.coerce.date().optional()
});
var TransactionStatusChangeSchema = z.object({
  from: z.nativeEnum(TransactionStatus),
  to: z.nativeEnum(TransactionStatus),
  changedAt: z.coerce.date(),
  reason: z.string().optional(),
  triggeredBy: z.string().optional()
});
var FloteTransactionSchema = z.object({
  id: z.string().uuid(),
  orderId: z.string(),
  customerId: z.number().int().positive(),
  amount: z.number().positive(),
  currency: z.nativeEnum(Currency),
  paymentMethod: z.nativeEnum(PaymentMethod),
  achDetails: AchDetailsSchema.optional(),
  status: z.nativeEnum(TransactionStatus),
  statusHistory: z.array(TransactionStatusChangeSchema).optional(),
  description: z.string().optional(),
  metadata: z.record(z.unknown()).optional(),
  provider: z.nativeEnum(PaymentProvider),
  providerTransactionId: z.string().optional(),
  providerMetadata: z.record(z.unknown()).optional(),
  checkSerialNumber: z.string().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  completedAt: z.coerce.date().optional()
});
var AchPaymentSchema = z.object({
  bankAccountId: z.string().uuid(),
  processingSpeed: z.nativeEnum(AchProcessingSpeed),
  entryDescription: z.string().min(1).max(100)
});
var CreateTransactionRequestSchema = z.object({
  orderId: z.string(),
  customerId: z.number().int().positive(),
  amount: z.number().positive(),
  paymentMethod: z.nativeEnum(PaymentMethod),
  description: z.string().optional(),
  achPayment: AchPaymentSchema.optional()
});
var UpdateTransactionStatusRequestSchema = z.object({
  transactionId: z.string().uuid(),
  status: z.nativeEnum(TransactionStatus),
  reason: z.string().optional(),
  providerMetadata: z.record(z.unknown()).optional()
});
var TransactionValidationResultSchema = z.object({
  valid: z.boolean(),
  errors: z.array(z.string()).optional(),
  warnings: z.array(z.string()).optional()
});
var RefundTransactionRequestSchema = z.object({
  transactionId: z.string().uuid(),
  amount: z.number().positive().optional(),
  reason: z.string().optional()
});
var CancelTransactionRequestSchema = z.object({
  transactionId: z.string().uuid(),
  reason: z.string().optional()
});
var TransactionQueryFiltersSchema = z.object({
  orderId: z.string().optional(),
  customerId: z.number().int().positive().optional(),
  status: z.nativeEnum(TransactionStatus).optional(),
  paymentMethod: z.nativeEnum(PaymentMethod).optional(),
  provider: z.nativeEnum(PaymentProvider).optional(),
  createdAfter: z.coerce.date().optional(),
  createdBefore: z.coerce.date().optional()
});
export {
  AchDetailsSchema,
  AchPaymentSchema,
  AchProcessingSpeed,
  BankAccountType,
  CancelTransactionRequestSchema,
  CreateTransactionRequestSchema,
  Currency,
  FloteTransactionSchema,
  PaymentMethod,
  PaymentProvider,
  RefundTransactionRequestSchema,
  TransactionQueryFiltersSchema,
  TransactionStatus,
  TransactionStatusChangeSchema,
  TransactionValidationResultSchema,
  UpdateTransactionStatusRequestSchema
};
